import http from "@/plugins/axios_plugin";

const options = {
  responseType: "blob",
};

class ServiceImpressoes {
  listarPedidos(params) {
    return http
      .get("/api/impressoes/pedidos/listar", { ...options, params })
      .then((response) => response.data);
  }

  listarProdutos(params) {
    return http
      .get("/api/impressoes/produtos/listar", { ...options, params })
      .then((response) => response.data);
  }

  listarClientes(params) {
    return http
      .get("/api/impressoes/clientes/listar?impressao", { ...options, params })
      .then((response) => response.data);
  }

  fichaDoCliente(params) {
    return http
      .get("/api/clientes/" + params.cliente_id + "/ficha", {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  listarFornecedores(params) {
    return http
      .get("/api/impressoes/fornecedores/listar", { ...options, params })
      .then((response) => response.data);
  }

  listarRepresentantes(params) {
    return http
      .get("/api/impressoes/representantes/listar", { ...options, params })
      .then((response) => response.data);
  }

  imprimirPedido(params) {
    return http
      .get("/api/impressoes/pedidos/" + params.pedido_id, {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  imprimirPedidoCliente(params) {
    return http
      .get("/api/impressoes/pedidos/cliente/" + params.pedido_cliente_id, {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  listarStands(params) {
    return http
      .get(`/api/impressoes/rodada/${params.rodada_id}/stands`, {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  imprimirListaClientesRodada(params) {
    return http
      .get(`/api/impressoes/rodadas/${params.rodada_id}/clientes`, {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  imprimirEtiquetasClientesRodada(params) {
    return http
      .get(`/api/impressoes/rodadas/${params.rodada_id}/etiquetas/clientes`, {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  imprimirListaFornecedoresRodada(params) {
    return http
      .get(`/api/impressoes/rodadas/${params.rodada_id}/fornecedores`, {
        ...options,
        params,
      })
      .then((response) => response.data);
  }

  listarImpressoesPendentes() {
    return http
      .get(`/api/impressoes/pendentes`)
      .then((response) => response.data);
  }
}

export default new ServiceImpressoes();
